import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Keyboard } from "./keyboard-CML2Vzkw.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as A11y } from "./a11y-DJiWS7ax.js";
//#region src/scripts/extenders/collection-tabs.js
var CollectionTabsSlider = class extends HTMLElement {
	constructor() {
		super();
		this.swiperElement = this.querySelector(".swiper");
		this.swiper = null;
	}
	connectedCallback() {
		this.initSlider();
	}
	disconnectedCallback() {
		this.destroySlider();
	}
	initSlider() {
		if (!this.swiperElement || this.swiper) return;
		const activeTabIndex = Array.from(this.querySelectorAll(".collection-tabs__button")).findIndex((tab) => tab.matches("[aria-current=\"page\"]"));
		this.swiper = new Swiper(this.swiperElement, {
			modules: [
				A11y,
				Keyboard,
				Mousewheel
			],
			direction: "horizontal",
			slidesPerView: "auto",
			initialSlide: Math.max(activeTabIndex, 0),
			keyboard: { enabled: true },
			mousewheel: { forceToAxis: true },
			a11y: { enabled: true }
		});
	}
	destroySlider() {
		if (!this.swiper) return;
		this.swiper.destroy(true, true);
		this.swiper = null;
	}
};
if (customElements.get("collection-tabs-slider") === void 0) customElements.define("collection-tabs-slider", CollectionTabsSlider);
//#endregion
